export default "__VITE_ASSET__DSUP6xAa__"